import { NavLink, useMatch } from "react-router-dom";
import { LayoutDashboard, Users, Building2, CreditCard, Activity, type LucideIcon } from "lucide-react";

const cockpitNav: { label: string; path: string; icon: LucideIcon; end?: boolean }[] = [
  { label: "Dashboard", path: "/cockpit", icon: LayoutDashboard, end: true },
  { label: "Utilisateurs", path: "/cockpit/users", icon: Users },
  { label: "Dossiers", path: "/cockpit/dossiers", icon: Building2 },
  { label: "Abonnements", path: "/cockpit/abonnements", icon: CreditCard },
  { label: "Activité", path: "/cockpit/activite", icon: Activity },
];

function NavRow({ label, path, icon: Icon, end }: (typeof cockpitNav)[number]) {
  const match = useMatch({ path, end: end ?? false });
  const isActive = !!match;
  return (
    <NavLink
      to={path}
      end={end}
      className={`flex items-center gap-3 rounded-lg border-l-[3px] py-2.5 pl-2.5 pr-3 text-sm font-medium transition-colors ${
        isActive
          ? "border-orange-500 bg-slate-800 text-white shadow-inner"
          : "border-transparent text-slate-400 hover:bg-slate-800/60 hover:text-slate-200"
      }`}
    >
      <Icon size={18} strokeWidth={1.75} className={isActive ? "text-orange-500" : "text-slate-500"} />
      {label}
    </NavLink>
  );
}

export default function CockpitSidebar() {
  return (
    <aside className="flex w-56 shrink-0 flex-col border-r border-slate-800 bg-slate-950/80">
      <div className="border-b border-slate-800 px-4 py-5">
        <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">Woahda</div>
        <div className="mt-1 text-lg font-bold text-white">Cockpit</div>
      </div>
      <nav className="flex flex-1 flex-col gap-0.5 p-3">
        {cockpitNav.map((item) => (
          <NavRow key={item.path} {...item} />
        ))}
      </nav>
    </aside>
  );
}
